// extracted by mini-css-extract-plugin
module.exports = {"option":"MobileProfileOptions_option__21QkD","separator":"MobileProfileOptions_separator__th2JB","red":"MobileProfileOptions_red__1wMBv"};